import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { route } from 'nextjs-routes';

import useApiQuery from 'lib/api/useApiQuery';
import { AddressHighlightProvider } from 'lib/contexts/addressHighlight';
import useIsMobile from 'lib/hooks/useIsMobile';
import { TX } from 'stubs/tx';
import { Link } from 'toolkit/chakra/link';
import SocketNewItemsNotice from 'ui/shared/SocketNewItemsNotice';
import useNewTxsSocket from 'ui/txs/socket/useTxsSocketTypeAll';

import LatestTxsItem from './LatestTxsItem';
import LatestTxsItemMobile from './LatestTxsItemMobile';

const LatestTransactions = ({ txData }: { txData?: any[] }) => {
  
  const isMobile = useIsMobile();
  const txsCount = isMobile ? 2 : 6;
  const { data, isPlaceholderData, isError } = useApiQuery('general:homepage_txs', {
    queryOptions: {
      placeholderData: Array(txsCount).fill(TX),
    },
  });

  const { num, showErrorAlert } = useNewTxsSocket({ type: 'txs_home', isLoading: isPlaceholderData });

  if (isError) {
    return <Text mt={4}>No data. Please reload the page.</Text>;
  }

  if (data) {
    const txsUrl = route({ pathname: '/txs' });
   
    return (
      <>
        <SocketNewItemsNotice borderBottomRadius={0} url={txsUrl} num={num} showErrorAlert={showErrorAlert} isLoading={isPlaceholderData} />
        <Box mb={3} display={{ base: 'block', lg: 'none' }}>
          {data.slice(0, txsCount).map(((tx, index) => (
            <LatestTxsItemMobile
              key={tx.hash + (isPlaceholderData ? index : '')}
              tx={tx}
              isLoading={isPlaceholderData}
            />
          )))}
        </Box>
        <Box mb={3} display={{ base: 'none', lg: 'block' }}>
          {txData?.map(((tx, index) => {
            const formattedTx = {
              ...tx,
              from: { hash: tx.from },
              to: { hash: tx.to },
              fee: { value: tx.fee },
              transaction_types: tx.txType,
              block_number: tx.blockNumber,
              status: "sequencing",
            };
            return (
              <LatestTxsItem
                noLink={true}
                key={formattedTx.hash + (isPlaceholderData ? index : '')}
                tx={formattedTx}
                isLoading={isPlaceholderData}
              />
            )
          }))}
        </Box>
        <AddressHighlightProvider>
          <Box mb={3} display={{ base: 'none', lg: 'block' }}>
            {data.slice(0, txsCount).map(((tx, index) => (
              <LatestTxsItem
                key={tx.hash + (isPlaceholderData ? index : '')}
                tx={tx}
                isLoading={isPlaceholderData}
              />
            )))}
          </Box>
        </AddressHighlightProvider>
        <Flex justifyContent="center">
          <Link textStyle="sm" href={txsUrl}>View all transactions</Link>
        </Flex>
      </>
    );
  }

  return null;
};

export default LatestTransactions;
